var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.802 6.146A1.26 1.26 0 0 1 4 5.25h16c.563 0 1.044.38 1.198.896l-9.055 6.338a.25.25 0 0 1-.286 0zm-1.552.342V18.5A2.756 2.756 0 0 0 4 21.25h16a2.756 2.756 0 0 0 2.75-2.75V6.51m-1.5 1.43V18.5c0 .686-.564 1.25-1.25 1.25H4c-.686 0-1.25-.564-1.25-1.25V7.94l8.247 5.773a1.75 1.75 0 0 0 2.007 0zm1.5-1.452A2.756 2.756 0 0 0 20 3.75H4a2.756 2.756 0 0 0-2.75 2.738",
    clipRule: "evenodd"
  })));
};
export default SvgEmail;